module.exports = __webpack_public_path__ + "img/logo_topmark.23ece8ea.png";